export type ChargeHead = { col: string; label: string };
export type ChargeHeadGroup = { group: string; heads: ChargeHead[] };

export const CHARGE_HEAD_GROUPS: ChargeHeadGroup[] = [
    {
        group: "Freight",
        heads: [
            { col: "freight", label: "Freight" },
            { col: "additional_freight", label: "Additional Freight" },
            { col: "dmv_freight", label: "DMV Freight" },
            { col: "multi_modal_transportation_charges_sez", label: "Multi-Modal (SEZ)" },
        ],
    },
    {
        group: "Surcharges",
        heads: [
            { col: "surcharge", label: "Surcharge" },
            { col: "fsc", label: "FSC" },
            { col: "fov", label: "FOV" },
        ],
    },
    {
        group: "Documentation & Service",
        heads: [
            { col: "doc_charges", label: "Doc Charges" },
            { col: "lr_charges", label: "LR Charges" },
            { col: "service_charges", label: "Service Charges" },
            { col: "statistical_charges", label: "Statistical Charges" },
            { col: "dmv_incentive_charges", label: "DMV Incentive" },
        ],
    },
    {
        group: "Collection / Delivery",
        heads: [
            { col: "door_collection", label: "Door Collection" },
            { col: "door_delivery", label: "Door Delivery" },
            { col: "extra_collection_charges", label: "Extra Collection" },
            { col: "extra_delivery_charges", label: "Extra Delivery" },
        ],
    },
    {
        group: "Loading / Unloading",
        heads: [
            { col: "loading_charges", label: "Loading Charges" },
            { col: "unloading_charges", label: "Unloading Charges" },
            { col: "mechanized_loading_unloading_charges", label: "Mechanized Loading/Unloading" },
            { col: "plywood_charges", label: "Plywood Charges" },
        ],
    },
    {
        group: "Detention",
        heads: [
            { col: "enroute_detention_charges", label: "En-Route Detention" },
            { col: "loading_point_detention_charges", label: "Loading Point Detention" },
            { col: "unloading_point_detention_charges", label: "Unloading Point Detention" },
            { col: "demurage_charges", label: "Demurage" },
        ],
    },
    {
        group: "Vehicle & ODC Extras",
        heads: [
            { col: "vehicle_hiring_service", label: "Vehicle Hiring" },
            { col: "odc_charges", label: "ODC" },
            { col: "extra_height_charges", label: "Extra Height" },
            { col: "extra_length_charges", label: "Extra Length" },
            { col: "extra_weight_charges", label: "Extra Weight" },
            { col: "extra_width_charges", label: "Extra Width" },
        ],
    },
    {
        group: "Statutory & Other",
        heads: [
            { col: "insurance_charges", label: "Insurance" },
            { col: "union_charges", label: "Union Charges" },
            { col: "green_tax_charges", label: "Green Tax" },
            { col: "toll_charges", label: "Toll Charges" },
            { col: "other_charges", label: "Other Charges" },
            { col: "additional_charges", label: "Additional Charges" },
        ],
    },
];

export const CHARGE_HEAD_ORDER: ChargeHead[] = CHARGE_HEAD_GROUPS.flatMap(g => g.heads);
